import React from 'react';
import KbHome, { KbHomePageEntry } from './kb-home';

export default function renderKbHome(entry: KbHomePageEntry) {
    return <KbHome entry={entry} />;
}
